// extracted by mini-css-extract-plugin
export default {"projectContainer":"UnregisteredHome_projectContainer__2DNUY"};